import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Hero from './components/Hero';
import HotGrid from './components/HotGrid';
import DailyContestCTA from './components/DailyContestCTA';
import ReviewSection from './components/ReviewSection';
import FeatureGrid from './components/FeatureGrid';

export default function Home() {
  return (
    <>
      <title>51黑料吃瓜网 | 在线观看与不打烊 | 每日黑料大赛独家猛料</title>
      <meta name="description" content="51黑料吃瓜网在线观看与不打烊入口，汇聚每日黑料大赛独家猛料。提供51黑料网站、吃瓜视频、黑料不打烊等核心访问方式，实时追踪网红明星最新爆点。" />
      <meta name="keywords" content="51黑料吃瓜网,51黑料在线观看,51黑料不打烊,每日黑料大赛,51黑料网站,51黑料吃瓜,51黑料视频,黑料爆料" />
      <link rel="canonical" href="https://51heiliao.com/" />
      <meta property="og:title" content="51黑料吃瓜网 | 在线观看与不打烊 | 每日黑料大赛独家猛料" />
      <meta property="og:description" content="51黑料吃瓜网在线观看与不打烊入口，汇聚每日黑料大赛独家猛料。实时追踪网红明星最新爆点。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://51heiliao.com/" />
      <meta property="og:site_name" content="51黑料吃瓜网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="51黑料吃瓜网 | 在线观看与不打烊 | 每日黑料大赛独家猛料" />
      <meta name="twitter:description" content="51黑料吃瓜网在线观看与不打烊入口，汇聚每日黑料大赛独家猛料。实时追踪网红明星最新爆点。" />

      <SchemaOrg
        type="WebSite"
        data={{
          name: '51黑料吃瓜网',
          url: 'https://51heiliao.com/',
          description: '51黑料吃瓜网在线观看与不打烊入口，汇聚每日黑料大赛独家猛料。提供吃瓜视频、黑料不打烊等核心访问方式。',
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://51heiliao.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '51黑料吃瓜网',
          url: 'https://51heiliao.com/',
          description: '全网最热娱乐爆料内容平台，7×24小时不打烊',
          sameAs: [
            'https://weibo.com/51heiliao',
            'https://space.bilibili.com/51heiliao',
          ],
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '51黑料吃瓜网 - 首页',
          url: 'https://51heiliao.com/',
          description: '51黑料吃瓜网首页，汇聚每日黑料大赛独家猛料',
          isPartOf: {
            '@type': 'WebSite',
            name: '51黑料吃瓜网',
            url: 'https://51heiliao.com/',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <HotGrid />
          <DailyContestCTA />
          <ReviewSection />
          <FeatureGrid />
        </main>
        <Footer />
      </div>
    </>
  );
}